<div class="container">
  <tpl-loader-spinner [color]="color"></tpl-loader-spinner>
</div>
